import { Component, Input, SimpleChanges } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController, ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { ReservationsServices } from '../../services';
import moment from 'moment';
import { CompCreateReservationPage } from '../../../components/popups/create-reservation/create-reservation';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'page-reservation-calendar-day-view',
  templateUrl: 'reservation-calendar-day-view.html',
})
export class ReservationCalendarDayViewPage {
  @Input() reservation_config;
  @Input() selected_date;
  @Input() reservations_info_by_day;
  @Input() reservations_stripe_complete;

  completes_stripes: any = [];
  _reservation_config: any = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public reservationsServices: ReservationsServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private datePipe: DatePipe,
    public modalCtrl: ModalController) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.reservation_config) {
      this._reservation_config = JSON.parse(JSON.stringify(changes.reservation_config.currentValue));
    }
    if (changes.selected_date || changes.reservations_info_by_day || changes.reservations_stripe_complete) {
      if (changes.selected_date) {
        this.selected_date = changes.selected_date.currentValue;
      }
      setTimeout(() => {
        this.getCompleteStripes();
      }, 0);
    }
  }

  getCompleteStripes() {
    //Init extra variables
    this._reservation_config.form_stripes[0].stripe = 1;
    this._reservation_config.form_stripes[1].stripe = 2;
    this._reservation_config.form_stripes[2].stripe = 3;

    this._reservation_config.form_stripes[0].completed = false;
    this._reservation_config.form_stripes[1].completed = false;
    this._reservation_config.form_stripes[2].completed = false;

    this._reservation_config.form_stripes[0].persons = 0;
    this._reservation_config.form_stripes[1].persons = 0;
    this._reservation_config.form_stripes[2].persons = 0;

    this._reservation_config.form_stripes[0].reservations = [];
    this._reservation_config.form_stripes[1].reservations = [];
    this._reservation_config.form_stripes[2].reservations = [];

    //Get completed stripes, persons and reservations
    this.completes_stripes = this.reservationsServices.reservations_stripe_complete.filter(x => x.date === moment(this.selected_date).format('YYYY-MM-DD'));
    this.completes_stripes.forEach(stripe => {
      this._reservation_config.form_stripes[stripe.stripe - 1].completed = true;
      this._reservation_config.form_stripes[stripe.stripe - 1].completed_stripe_uid = stripe.UID;
    });
    this.reservationsServices.total_reservations_by_day = 0;
    this.reservationsServices.reservations_info_by_day.forEach(reservation => {
      if (!reservation.persons) {
        reservation.persons = (reservation.adults + reservation.children);
      }
      if (reservation.state != 'denied' && reservation.state != 'anulated') {
        this.reservationsServices.total_reservations_by_day += reservation.persons;
        this._reservation_config.form_stripes[reservation.stripe - 1].persons += (reservation.adults + reservation.children);
      }
      this._reservation_config.form_stripes[reservation.stripe - 1].reservations.push(reservation);
    });
  }

  openReservation(reservation) {
    let profileModal = this.modalCtrl.create(CompCreateReservationPage, {
      update_state: true,
      reservation: reservation,
      reservation_config: this.reservation_config
    });
    profileModal.present();
  }

  addCompleteStripe(stripe) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('reservas-day-marcar-franja-completa'),
      message: this.translate.instant('reservas-day-seguro-marcar-franja-completa'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
            stripe.completed = false;
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Reservations', 'Reservations - Complete Stripe - Update', this.globals.restaurant.email, 'Create/Update', 'Update complete stripe', 'Reservations', '');
            this.reservationsServices.afs.collection('reservation_complete').add({
              'UID_RESTAURANT': this.globals.restaurant_uid,
              'date': this.datePipe.transform(this.selected_date, "yyyy-MM-dd"),
              'stripe': stripe.stripe,
            }).then(doc => {
              stripe.completed_stripe_uid = doc.id;
              stripe.completed = true;
            });
          }
        }
      ]
    });
    alert.present();
  }

  deleteCompletedStripe(stripe) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('reservar-day-marcar-franja-libre'),
      message: this.translate.instant('reservas-day-seguro-marcar-franja-libre'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
            stripe.completed = true;
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.reservationsServices.deleteStripeComplete(stripe.completed_stripe_uid);
            stripe.completed_stripe_uid = '';
            stripe.completed = false;
          }
        }
      ]
    });
    alert.present();
  }

  btnClass(state) {
    let cssClasses = {};
    switch (state) {
      case 'pending':
        cssClasses = {
          'btn-outline-pending': true
        }
        break;
      case 'accepted':
        cssClasses = {
          'btn-outline-accepted': true
        }
        break;
      case 'in_table':
        cssClasses = {
          'btn-outline-in-table': true
        }
        break;
      case 'finished':
        cssClasses = {
          'btn-outline-finished': true
        }
        break;
      case 'denied':
        cssClasses = {
          'btn-outline-denied': true
        }
        break;
      case 'not_presented':
        cssClasses = {
          'btn-outline-not-presented': true
        }
        break;
      case 'queue':
        cssClasses = {
          'btn-outline-queue': true
        }
        break;
      case 'anulated':
        cssClasses = {
          'btn-outline-denied': true
        }
        break;
    }
    return cssClasses;
  }

  checkStripe(stripe) {
    let _return = true;
    if (stripe) {
      if (this.reservationsServices.stripes.findIndex(x => x == stripe) == -1) {
        _return = false;
      }
    }
    return _return;
  }

  changesStripeComplete(stripe) {
    if (stripe.completed) {
      this.deleteCompletedStripe(stripe);
    } else {
      this.addCompleteStripe(stripe);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-calendar/reservation-calendar-day-view/reservation-calendar-day-view.ts